import { CONFIRM_INFO_SERVICES } from '@/models/confirmInfo'
import { useFeatureFlag } from '@/models/flag'
import { useInsuranceApplication } from '@/models/insuranceApplication'
import { showsQuotesPage, useCurrentUser, useOrgApplication } from '@/models/user'

/** The signed-in customer's own application, and whether it has reached the quotes page yet. */
export function useCustomerApplication() {
  const { user } = useCurrentUser({ enabled: true })
  const { application, isLoading } = useOrgApplication(user?.currentOrg.id)
  // The page polls this query, so reading it moves the customer on the moment carriers are asked.
  const { data: polled } = useInsuranceApplication({ id: application?.id, enabled: false })
  const current = polled ?? application
  const showsQuotes = !!application && showsQuotesPage(user?.currentOrg, current)
  // The flag the page's review step reads, so the nav waits on the same confirmation.
  const needsReview = !!current?.needsReviewAttestation
  // Without the flag the chat ends at its review with a promise to call, so there is nothing to confirm.
  const indicationsOnboarding = useFeatureFlag('ENABLE_INDICATIONS_ONBOARDING')
  const reviewsOnPage =
    indicationsOnboarding && !showsQuotes && CONFIRM_INFO_SERVICES.includes(current?.action.service ?? '')

  return { user, application, isLoading, showsQuotes, needsReview, reviewsOnPage }
}
